let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3K3Qm")).then(() => parcelRequire('cRU8U'));